<wiz-vgroup width="100%" height="100%" style="overflow: hidden" 
class="section-container" 
gap="0">
  <wiz-hgroup (click)="showMode('camera')" verticalAlign="center">
    <wiz-icon 
        style="cursor: pointer; font-size: 20px"
        class="image-back-white"
        ><mat-icon>camera</mat-icon></wiz-icon>
    <wiz-label wizLabel="$.image.mode.camera.$"></wiz-label>    
  </wiz-hgroup>

  <wiz-hgroup (click)="showMode('folder')" verticalAlign="center">
    <wiz-icon 
        style="cursor: pointer; font-size: 20px"
        class="image-back-white"
        ><mat-icon>folder</mat-icon></wiz-icon>
    <wiz-label wizLabel="$.image.mode.folder.$"></wiz-label>    
  </wiz-hgroup>   
</wiz-vgroup>
